document.querySelectorAll(".image-swiper").forEach(function(item){
let imageSlider = item.dataset.view;
var swiper = new Swiper(item, {
      slidesPerView: imageSlider,
      spaceBetween: 20,
      navigation: {
         nextEl: ".image-swiper .swiper-button-next",
         prevEl: ".image-swiper .swiper-button-prev",
        clickable: true,
      }, 
     breakpoints: {
          767: {
            slidesPerView: 1
          },
          1024: {
            slidesPerView: 2
          },
          1600: {
            slidesPerView: imageSlider
          },
          3000: {
            slidesPerView: imageSlider
          }
        },
    }); 
})
if(document.querySelector(".review-swiper")){
let reviewSlider = document.querySelector(".review-swiper").dataset.view; 
var swiper = new Swiper(".review-swiper", {
      slidesPerView: reviewSlider,
      navigation: {
         nextEl: ".review-swiper .swiper-button-next",
         prevEl: ".review-swiper .swiper-button-prev",
        clickable: true,
      }, 
     breakpoints: {
          767: {
            slidesPerView: 1
          },
          1024: {
            slidesPerView: 2
          },
          1600: {
            slidesPerView: reviewSlider
          },
          3000: {
            slidesPerView: reviewSlider
          }
        },
    }); 
}